import React, { useContext } from "react";
import "./aboutus.css";
import ourteam from "../photos/our-team.png";
import member from "../photos/member.jpg";
import journey1 from "../photos/journey1.png";
import journey2 from "../photos/journey2.png";
import journey3 from "../photos/journey3.png";
import journey4 from "../photos/journey4.png";
import vehicle1 from "../photos/vehicle1.png";
import vehicle2 from "../photos/vehicle2.png";
import vehicle3 from "../photos/vehicle3.png";
import { MdNavigateNext, MdNavigateBefore } from "react-icons/md";
import { LanguageContext } from "../settings/LanguageContext"; // adjust path if needed

const teammembers = [
  {
    id: 1,
    photo: member,
    nameEN: "Tom Holand",
    nameRU: "Том Холанд",
    jobtitleEN: "Driver/Guide",
    jobtitleRU: "Водитель/Гид",
    descriptionEN:
      "Lorem ipsum dolor sit amet consectetur. Id ornare elementum mauris diam purus.",
    descriptionRU:
      "Лорем ипсум долор сит амет консектетур. Ид орнаре элемендум mauris diam purus.",
  },
  {
    id: 2,
    photo: member,
    nameEN: "Karlen Jabiev",
    nameRU: "Карлен Джабиев",
    jobtitleEN: "Driver/Guide",
    jobtitleRU: "Водитель/Гид",
    descriptionEN:
      "Lorem ipsum dolor sit amet consectetur. Id ornare elementum mauris diam purus.",
    descriptionRU:
      "Лорем ипсум долор сит амет консектетур. Ид орнаре элемендум mauris diam purus.",
  },
  {
    id: 3,
    photo: member,
    nameEN: "Agob Babij",
    nameRU: "Агоб Бабиж",
    jobtitleEN: "Driver/Guide",
    jobtitleRU: "Водитель/Гид",
    descriptionEN:
      "Lorem ipsum dolor sit amet consectetur. Id ornare elementum mauris diam purus.",
    descriptionRU:
      "Лорем ипсум долор сит амет консектетур. Ид орнаре элемендум mauris diam purus.",
  },
  {
    id: 4,
    photo: member,
    nameEN: "Duduk Kaleb",
    nameRU: "Дудук Калеб",
    jobtitleEN: "Driver/Guide",
    jobtitleRU: "Водитель/Гид",
    descriptionEN:
      "Lorem ipsum dolor sit amet consectetur. Id ornare elementum mauris diam purus.",
    descriptionRU:
      "Лорем ипсум долор сит амет консектетур. Ид орнаре элемендум mauris diam purus.",
  },
];

const vehicles = [
  {
    id: 1,
    photo: vehicle3,
    carnameEN: "Sedan",
    carnameRU: "Седан",
    directionEN: "For private and smooth city rides",
    directionRU: "Для частных и комфортных поездок по городу",
  },
  {
    id: 2,
    photo: vehicle2,
    carnameEN: "Minivans",
    carnameRU: "Минивэны",
    directionEN: "For families and groups needing extra space",
    directionRU: "Для семей и групп, которым нужно больше места",
  },
  {
    id: 3,
    photo: vehicle1,
    carnameEN: "Mini Buses",
    carnameRU: "Мини-автобусы",
    directionEN: "For larger groups traveling together",
    directionRU: "Для больших групп, путешествующих вместе",
  },
];

const About = () => {
  const { lang } = useContext(LanguageContext);

  return (
    <div className="about-main">
      <div className="aboutus-1stcontainer">
        <div className="about-text">
          <h3>{lang === "EN" ? "About Us" : "О нас"}</h3>
          <p>
            {lang === "EN"
              ? `Founded in 2018, Memory Maker Travel specializes in private and group tours across Armenia, delivering exceptional travel experiences that combine cultural richness, historic sites, and breathtaking landscapes.
Our team comprises dedicated professionals with extensive experience in travel and hospitality. We are committed to providing seamless, well-planned journeys, ensuring every detail is carefully managed for your comfort and enjoyment.
At Memory Maker Travel, our guiding principle is simple: we treat our guests the way we would want to be treated when traveling abroad. This philosophy shapes every tour we create, offering personalized service, genuine care, and a deep respect for our clients.
With a focus on professionalism, reliability, and authentic experiences, we strive to make every trip memorable, enriching, and truly exceptional.`
              : `Основанная в 2018 году, Memory Maker Travel специализируется на индивидуальных и групповых турах по Армения, предлагая исключительные туристические впечатления, сочетающие культурное богатство, исторические достопримечательности и захватывающие природные пейзажи.
Наша команда состоит из преданных своему делу профессионалов с обширным опытом работы в сфере туризма и гостеприимства. Мы стремимся обеспечивать комфортные и тщательно организованные путешествия, уделяя внимание каждой детали для вашего удобства и удовольствия.
В Memory Maker Travel наш основной принцип прост: мы относимся к нашим гостям так, как хотели бы, чтобы относились к нам во время путешествий за границей. Эта философия лежит в основе каждого создаваемого нами тура, предлагая персонализированный сервис, искреннюю заботу и глубокое уважение к нашим клиентам.
Сосредоточившись на профессионализме, надежности и подлинных впечатлениях, мы стремимся сделать каждую поездку запоминающейся, насыщенной и по-настоящему исключительной.`}
          </p>
        </div>
        <div className="about-photo">
          <img src={ourteam} alt="ourteam" />
        </div>
      </div>

      <div className="yellowbg">
        <h3 id="our-team">{lang === "EN" ? "Our Team" : "Наша команда"}</h3>
        <p>
          {lang === "EN"
            ? "Our experienced team combines local knowledge and professional service to deliver safe, comfortable, and unforgettable travel experiences."
            : "Наша опытная команда сочетает местные знания и профессиональный сервис, чтобы обеспечить безопасные, комфортные и незабываемые путешествия."}
        </p>
      </div>

      <div className="our-team">
        {teammembers.map((member) => (
          <div key={member.id} className="each-member">
            <div className="photo-round">
              <img src={member.photo} alt="member" />
            </div>
            <h4>{lang === "EN" ? member.nameEN : member.nameRU}</h4>
            <h5>{lang === "EN" ? member.jobtitleEN : member.jobtitleRU}</h5>
            <p>{lang === "EN" ? member.descriptionEN : member.descriptionRU}</p>
          </div>
        ))}
      </div>

      <div className="our-journey-photos">
        <img src={journey1} alt="journey" className="img-square-1" />
        <img src={journey2} alt="journey" className="img-square-2" />
        <img src={journey3} alt="journey" className="img-tall" />
        <img src={journey4} alt="journey" className="img-wide" />
      </div>

      <div className="our-vehicles">
        <h4 id="our-vehicles">{lang === "EN" ? "Vehicle Types" : "Типы транспортных средств"}</h4>
        <p>
          {lang === "EN"
            ? "We offer a comfortable and well-maintained fleet to suit every travel need. Choose from our Sedans for private and smooth city rides, Minivans for families and small groups needing extra space, or Mini Buses for larger groups traveling together. All vehicles are modern, air-conditioned, and driven by experienced drivers to ensure a safe, reliable, and enjoyable journey."
            : "Мы предлагаем комфортабельный и хорошо обслуживаемый автопарк для любых потребностей путешествия. Выбирайте Седаны для частных и комфортных поездок по городу, Минивэны для семей и небольших групп, или Мини-автобусы для больших групп. Все транспортные средства современные, с кондиционером и управляются опытными водителями для безопасного и приятного путешествия."}
        </p>

        <div className="vehicle-types">
          {vehicles.map((v) => (
            <div className="tours-gallery" key={v.id}>
              <div className="tour-gallery-point">
                <img src={v.photo} alt="vehicle" />
                <div className="tour-text-book">
                  <h2 className="tour-pack-title">{lang === "EN" ? v.carnameEN : v.carnameRU}</h2>
                  <p className="tour-pack-text">{lang === "EN" ? v.directionEN : v.directionRU}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="left-right-buttons">
        <div>
          <MdNavigateBefore />
        </div>
        <div>
          <MdNavigateNext />
        </div>
      </div>
    </div>
  );
};

export default About;
